import { App } from "./App";
import { createRoot } from "react-dom/client";

Array.from(document.querySelectorAll('.correcao-tri-app')).forEach((element) => {
    const root = createRoot(element);
    root.render(<App />);
});
